@import "@/ui/variables.css";

.buttonRoot {
  --background: var(--gray-light);
  --foreground: white;

  background-color: var(--background);
  color: var(--foreground);

  text-decoration: none;

  border: none;
  border-radius: var(--radius);
  padding: var(--space-2) var(--space-3);

  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  box-sizing: border-box;

  anchor-scope: --button;
  anchor-name: --button;

  font-family: var(--font);
  font-size: 0.9rem;

  &[data-variant="destructive"] {
    --background: var(--red);
  }

  &[data-variant="primary"] {
    --background: var(--yellow);
    --foreground: var(--gray-dark);
  }

  &[data-variant="transparent"] {
    --background: none;
    padding: 0;
  }

  &[data-variant="ghost"] {
    --background: transparent;
    --foreground: var(--gray-dark);
    border: 2px solid;

    &:hover {
      --background: var(--gray-dark);
      --foreground: var(--white);
    }
  }

  &[data-loading="true"] {
    color: oklch(from var(--foreground) l c h / 0);
    /* spinner  */
    div {
      position: absolute;
      position-area: center;
      position-anchor: --button;
    }
  }

  &[data-size="small"] {
    padding: var(--space-1) var(--space-2);
  }
}

.buttonRoot:disabled {
  background-color: oklch(from var(--background) calc(l + 0.2) c h) !important;
}

.buttonRoot:hover {
  background-color: oklch(from var(--background) calc(l + 0.1) c h);
}

.buttonRoot:active {
  background-color: oklch(from var(--background) calc(l - 0.1) c h);
}

.csrfButtonForm button {
  width: 100%;
}
